// extracted by mini-css-extract-plugin
export default {"container":"ArrowToTop_container__m7+OV","arrowToTopIcon":"ArrowToTop_arrowToTopIcon__UR8pb"};